import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'ow-scheduled-enddate';

const validator = () => null;

const vFParams = {
  fieldTitle: 'End date/time',
};

const OWScheduledEndDate = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { OWScheduledEndDate };
